import { useEffect, useState } from "react";
import { LOVABLE_IFRAME_URL } from "../../utils/appStore";
import "./LovableIframePage.scss";

const LovableIframePage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.body.classList.add("lovable-iframe-page");
    return () => {
      document.body.classList.remove("lovable-iframe-page");
    };
  }, []);

  return (
    <div className="lovable-iframe-page__shell">
      {isLoading && (
        <div className="lovable-iframe-page__loading" aria-live="polite">
          Loading…
        </div>
      )}
      <iframe
        src={LOVABLE_IFRAME_URL}
        title="FAM — For All Milestones"
        className="lovable-iframe-page__frame"
        onLoad={() => setIsLoading(false)}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default LovableIframePage;
